import classNames from 'classnames';
import styles from './styles.module.scss';
import { Button } from 'components';
import moment from 'moment';
import { useState } from 'react';
import { postReinviteClientById } from 'api/clientsList';
import { showSuccessMessage } from 'helpers';

export const PendingClient = ({ contact, clientId }) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const [loading, setLoading] = useState(false);

  const { InviteLink } = contact || {};

  const handleCopy = () => {
    navigator.clipboard.writeText(InviteLink);
    setShowTooltip(true);
    setTimeout(() => setShowTooltip(false), 1000);
  };

  const handleInvite = async () => {
    setLoading(true);
    await postReinviteClientById({ id: clientId });
    setLoading(false);
    showSuccessMessage('Invitation resent successfully');
  };

  const Icon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none">
      <path
        d="M20.8415 9.47153C20.8415 13.6573 17.4483 17.0505 13.2625 17.0505C9.0768 17.0505 5.68359 13.6573 5.68359 9.47153C5.68359 5.28579 9.0768 1.89258 13.2625 1.89258C17.4483 1.89258 20.8415 5.28579 20.8415 9.47153Z"
        stroke="#747475"
        strokeWidth="2.5"
      />
      <path
        d="M2.83984 29.368C3.48932 25.3193 6.47532 21.7891 9.787 21.7891H16.7346C20.0463 21.7891 23.0325 25.3193 23.6819 29.368"
        stroke="#747475"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx="26.5263"
        cy="26.5263"
        r="7.27632"
        fill="#F4F5F6"
        stroke="#747475"
        strokeWidth="2.5"
      />
      <path
        d="M23.6836 26.5254H29.3678"
        stroke="#747475"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );

  return (
    <div className={styles.main}>
      <div className={styles.card}>
        <div className={styles.icon}>
          <Icon />
        </div>
        <p className={styles.line1}>{contact?.FirstName}’s account isn’t activated yet.</p>
        {contact?.SendInvitation && (
          <p className={styles.line2}>
            The email invitation was last sent: {moment(contact?.InviteSentAt).format('MM/DD/YYYY')}
          </p>
        )}
        <div className={styles.buttonContainer}>
          <Button
            className={classNames(styles.cancel, styles.button)}
            titleClassName={styles.titleClassName}
            title="Copy Invite Link"
            onClick={handleCopy}
          />
          <Button
            className={styles.button}
            titleClassName={styles.titleClassName}
            title={contact?.SendInvitation ? 'Resend Invitation' : 'Send Invitation'}
            onClick={handleInvite}
            isPending={loading}
          />
          {
            <span className={classNames(styles.tooltip, { [styles.show]: showTooltip })}>
              Link Copied
            </span>
          }
        </div>
      </div>
    </div>
  );
};
